import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { HomePage, SeeMorePage, ArsskyrslaPage } from './pages';
import { Footer, ScrollToTop } from './components';
import data from './lang/arsskyrsla-data.json';
import './styles/styles.css';

function App() {
  const footer = data.footer;
  const theme = extendTheme({
    colors: {
      blue: {
        600: '#00007C',
      },
    },
    fonts: {
      body: 'Brix, sans-serif',
      heading: 'Brix, sans-serif',
    },
    components: {
      Heading: {
        variants: {
          heading1: {
            fontFamily: 'Brix, sans-serif',
            fontSize: '69px',
            fontWeight: '700',
            lineHeight: '76px',
            textAlign: 'left',
          },
          heading2: {
            fontFamily: 'Brix, sans-serif',
            fontSize: '55px',
            fontWeight: '700',
            lineHeight: '66px',
            letterSpacing: '0em',
            textAlign: 'left',
          },
          heading3: {
            fontFamily: 'Brix, sans-serif',
            fontSize: '44px',
            fontWeight: '700',
            lineHeight: '52.8px',
            letterSpacing: '0em',
            textAlign: 'left',
          },
          heading4: {
            fontFamily: 'Brix, sans-serif',
            fontSize: '35px',
            fontWeight: '700',
            lineHeight: '42px',
            letterSpacing: '0em',
            textAlign: 'left',
          },
          heading5: {
            fontFamily: 'Brix, sans-serif',
            fontSize: '28px',
            fontWeight: '700',
            lineHeight: '36.4px',
            letterSpacing: '0em',
            textAlign: 'left',
          },
        },
      },
    },
    textStyles: {
      text: {
        fontFamily: 'Brix, sans-serif',
      },
      customBodyMedium: {
        fontFamily: 'Brix, sans-serif',
        fontSize: '18px',
        fontWeight: '400',
        lineHeight: '27px',
        letterSpacing: '0em',
        textAlign: 'left',
      },
      labelBeforeTitle: {
        fontFamily: 'Brix, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '21px',
        letterSpacing: '0em',
        textAlign: 'left',
      },
      linkTo: {
        fontFamily: 'Brix, sans-serif', // Assuming Brix Sans is loaded
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '27px',
        letterSpacing: '0em',
        color: '#00007C',
        _hover: {
          textDecoration: 'underline', // Example for hover state background color change
        },
        // Add more states as needed (_active, _focus, etc.)
      },
      bannerHeader: {
        fontFamily: 'Brix, sans-serif',
        fontSize: '69px',
        fontWeight: '700',
        lineHeight: '76px',
        textAlign: 'left',
        color: '#FFFFFF',
      },
      bannerText: {
        fontFamily: 'Brix, sans-serif',
        fontSize: '22px',
        fontWeight: '400',
        lineHeight: '28px',
        textAlign: 'left',
        color: '#FFFFFF',
      },
    },
  });

  return (
    <ChakraProvider theme={theme}>
      <Router>
        <ScrollToTop />
        <div>
          <Routes>
            <Route path="/" exact element={<HomePage />} />
            <Route
              path="/seemore/:id"
              element={<SeeMorePage type="seeMore" />}
            />
            <Route
              path="/:any/seemore/:id"
              element={<SeeMorePage type="seeMore" />}
            />
            <Route
              path="/starfsemin"
              element={<ArsskyrslaPage type="Starfsemin" />}
            />
            {false && (
              <>
                <Route
                  path="/samstaedan"
                  element={<ArsskyrslaPage type="Samstæðan" />}
                />
                <Route
                  path="/siminn"
                  element={<ArsskyrslaPage type="Síminn" />}
                />
              </>
            )}
            <Route
              path="/arsreikningur"
              element={<ArsskyrslaPage type="Ársreikningur" />}
            />
            <Route
              path="/sjalfbaerni"
              element={<ArsskyrslaPage type="Sjálfbærni" />}
            />
            {/* Add more routes as needed */}
          </Routes>
          <Footer footerData={footer} />
        </div>
      </Router>
    </ChakraProvider>
  );
}

export default App;
